import { SxProps, Theme } from "@mui/material";
import { EControlLabels } from "../../../components/masterData/FormBuilder/controls/controlList/ControlListTypes";

export enum EValidationErrorType {
  REQUIRED = "required",
  ALPHABETS = "alphabets",
  NUMERICS = "numeric",
  ALPHANUMERIC = "alpha-numeric",
  FUTUREDATE = "restrict-future-date-validation",
  PASTDATE = "restrict-past-date-validation",
}

type ValidateStepFunction = () => Promise<boolean>;

type SetValidateStep = React.Dispatch<
  React.SetStateAction<ValidateStepFunction>
>;

// Define props interface
export interface IDynamicFormProps {
  formData: IMainForm;
  onSubmit: (values: any) => void;
  setValidateStep?: SetValidateStep;
  isHideSubmitBtn?: boolean;
  sxControlStyle?: SxProps<Theme>;
  isDisableAllFields?: boolean;
  onCancel?: () => void;
}

// Control types
export type controlType =
  | EControlLabels.SECTION
  | EControlLabels.SHORT_ANSWER
  | EControlLabels.LONG_ANSWER
  | EControlLabels.SINGLE_CHOICE
  | EControlLabels.MULTIPLE_CHOICES
  | EControlLabels.FILE_UPLOAD
  | EControlLabels.DATE_PICKER
  | EControlLabels.TIME_PICKER
  | EControlLabels.RANGE_SCALE
  | null;

export interface ISingleChoiceOption {
  value: string;
  tinyForms: string[];
}

// Tiny form values
export interface ITinyFormValue {
  selectedForms: string[];
}

// Range values
export interface IRangeValues {
  startRange: string;
  endRange: string;
  stepRange: string;
  isInputProvide: boolean;
}

export interface IQuestionData {
  question: string;
  validation: string[];
  option?: ISingleChoiceOption[];
  rangeValues?: IRangeValues;
  timeFormat?: string;
  fileTypes?: string[];
}

export interface IQuestion {
  id: string;
  data: IQuestionData;
  icon?: string;
  label: string;
  typeOfControl: controlType;
  fieldId: string;
  answer: string;
  answerId: string;
  subForms: ISubFroms[];
}

export interface ISection {
  id: string;
  name: string;
  questions: IQuestion[];
}

export interface IMainForm {
  id: string;
  formName: string;
  type: string;
  version: number;
  sections: ISection[];
}

export interface ISubFroms {
  formId: string;
  formVersion: number;
  formName: string;
  formCategory: string;
  sections: ISection[];
}
